<template>
  <img class="lenny" src="@/assets/img/meme/lenny.svg" />
</template>

<script>
export default {
  name: "lenny",
  data() {
    return {};
  },
  methods: {}
};
</script>

<style lang="scss" scoped></style>
